import script from "./PodcastAdminCampaignsList.vue?vue&type=script&setup=true&lang=js"
export * from "./PodcastAdminCampaignsList.vue?vue&type=script&setup=true&lang=js"

import "./PodcastAdminCampaignsList.vue?vue&type=style&index=0&id=acccb828&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-acccb828"]])

export default __exports__